import { AssetSubscriptionV26 } from 'src/app/models-v26/asset-subscription-v26';
import { DeliveryItemV26 } from 'src/app/models-v26/deliveryitem-v26';
import { ActionResponse } from 'src/app/models/action-response';
import { Desk } from 'src/app/models/desk';
import { CopyAssetDueDatesV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/copy-asset-wizard/activation-step/copy-asset-due-date-info';
import { CopyAssetAdditionalInfoV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/copy-asset-wizard/additional-step/additional-info';
import { CopyAssetInitStepV26 } from 'src/app/shared-components-v26/allocation-wizard-modal-dialogs/copy-asset-wizard/init-step/init-step';

export interface State {
  initStep: CopyAssetInitStepV26;
  initAssetServiceStep: AssetSubscriptionV26[];
  deskStep: Desk;
  dueDatesStep: CopyAssetDueDatesV26;
  serviceStep: DeliveryItemV26[];
  addInfoStep: CopyAssetAdditionalInfoV26;
  newOrderResponse: ActionResponse;
  errorMessage: string;
}

export const initialState: State = {
  initStep: null,
  initAssetServiceStep: null,
  deskStep: null,
  dueDatesStep: { activationDate: null, deactivationDate: null },
  serviceStep: null,
  addInfoStep: null,
  newOrderResponse: null,
  errorMessage: null,
};
